import {
    REGISTER_UNIFIED_USER_STARTED,
    REGISTER_UNIFIED_USER_SUCCEEDED,
    REGISTER_UNIFIED_USER_FAILED,
    LOAD_UNIFIED_USERPROFILE_STARTED,
    LOAD_UNIFIED_USERPROFILE_SUCCEEDED,
    LOAD_UNIFIED_USERPROFILE_FAILED,
    VERIFY_UNIFIED_USER_STARTED,
    VERIFY_UNIFIED_USER_FAILED,
    VERIFY_UNIFIED_USER_SUCCEEDED,
    VerifyUserResult,
    UnifiedRegistrationActionTypes,
    UnifiedRegistrationModel,
    UserViewModel,
    RegisterUserResult,
    RETRIEVE_DECRYPTED_PROFILE_ID_STARTED,
    RETRIEVE_DECRYPTED_PROFILE_ID_SUCCEEDED,
    RETRIEVE_DECRYPTED_PROFILE_ID_FAILED,
    RETRIEVE_ENCRYPTED_PROFILE_ID_STARTED,
    RETRIEVE_ENCRYPTED_PROFILE_ID_SUCCEEDED,
    RETRIEVE_ENCRYPTED_PROFILE_ID_FAILED
} from './types';

const initialProfile = {
    email: '',
    firstName: '',
    lastName: '',
    title: '',
    organizationname: '',
    department: '',
    address: '',
    city: '',
    stateorProvince: '',
    country: '',
    postalCode: '',
    phone: '',
    addressType: 0,
    sourceUrl: '',
    error: undefined,
    crmGuid: '',
    subscriptions: [],
    activated: false
};

const initialVerify = {
    password: '',
    profileId: '',
    error: undefined,
    activated: false
}

const initialVerifyViewModel = {
    errorMessage: '',
    verificationData: initialVerify,
    verifyUserResult: { userProfile: { subscriptions: [], userName: '', email: '' }, message: '', success: false },
}

const userProfileSavedResult = {
    message: '',
    success: false
}

const initialState = {
    error: '',
    profileId: '',
    userProfileExists: false,
    userProfileSavedResult: userProfileSavedResult,
    userProfileData: initialProfile,
    verifyUserData: initialVerifyViewModel,
    loading: false
};



const reducer = (
    state = initialState,
    action: UnifiedRegistrationActionTypes
): UnifiedRegistrationModel => {
    switch (action.type) {
        case LOAD_UNIFIED_USERPROFILE_STARTED: {
            return {
                ...state,
                userProfileExists: false,
                loading: true
            };
        }
        case LOAD_UNIFIED_USERPROFILE_SUCCEEDED: {
            return {
                ...state,
                userProfileData: (action.payload as unknown) as UserViewModel,
                userProfileExists:((action.payload as unknown) as UserViewModel).crmGuid !== "" && ((action.payload as unknown) as UserViewModel).crmGuid !== "00000000-0000-0000-0000-000000000000",
                loading: false
            };
        }
        case LOAD_UNIFIED_USERPROFILE_FAILED: {
            return {
                ...state,
                userProfileExists: false,
                error: action.payload,
                loading: false
            };
        }

        case REGISTER_UNIFIED_USER_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case REGISTER_UNIFIED_USER_SUCCEEDED: {
            return {
                ...state,
                userProfileSavedResult: (action.payload as unknown) as RegisterUserResult,
                loading: false
            };
        }
        case REGISTER_UNIFIED_USER_FAILED: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }

        case VERIFY_UNIFIED_USER_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case VERIFY_UNIFIED_USER_FAILED: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        case VERIFY_UNIFIED_USER_SUCCEEDED: {
            return {
                ...state,
                error: !(((action.payload as unknown) as VerifyUserResult).success) ? ((action.payload as unknown) as VerifyUserResult).message : "",
                verifyUserData: {
                    verificationData: {
                        ...state.verifyUserData.verificationData
                    },
                    verifyUserResult: {
                        userProfile: ((action.payload as unknown) as VerifyUserResult).userProfile,
                        message: ((action.payload as unknown) as VerifyUserResult).message,
                        success: ((action.payload as unknown) as VerifyUserResult).success
                    }
                },
                loading: (false || ((action.payload as unknown) as VerifyUserResult).success),
            };
        }
        case RETRIEVE_DECRYPTED_PROFILE_ID_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case RETRIEVE_DECRYPTED_PROFILE_ID_SUCCEEDED: {
            return {
                ...state,
                profileId: action.payload,
                loading: false

            };
        }
        case RETRIEVE_DECRYPTED_PROFILE_ID_FAILED: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        case RETRIEVE_ENCRYPTED_PROFILE_ID_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case RETRIEVE_ENCRYPTED_PROFILE_ID_SUCCEEDED: {
            return {
                ...state,
                profileId: action.payload,
                loading: false

            };
        }
        case RETRIEVE_ENCRYPTED_PROFILE_ID_FAILED: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default: {
            return state;
        }
    }
};

export default reducer;
